import { jsx as _jsx } from "react/jsx-runtime";
var Iframe = function (_a) {
    var url = _a.url, height = _a.height, id = _a.id, title = _a.title;
    return (_jsx("div", { children: _jsx("iframe", { src: url, title: title, style: { width: "100%", height: height + "px" } }) }, id));
};
export default Iframe;
